import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchHomonyms, searchHomonyms } from "./homonymService";
import "./HomonymListPage.css";

const HomonymListPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const params = { page, size: 20 };
    const res = search
      ? await searchHomonyms({ keyword: search, ...params })
      : await fetchHomonyms(params);

    if (res.status === 200 && res.data?.status) {
      setItems(res.data.data || []);
      setTotalPages(res.data.totalPages || 0);
      setTotalItems(res.data.totalItems || 0);
    } else {
      setItems([]);
      setTotalPages(0);
      setTotalItems(0);
    }
    setLoading(false);
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <Navbar />
      <div className="homonym-page">
        <h1 className="homonym-title">🔤 Homonyms</h1>
        <p className="homonym-subtitle">Words that sound the same but have different meanings.</p>

        <div className="homonym-filters">
          <input
            className="homonym-search" type="text" placeholder="Search homonyms..."
            value={search} onChange={(e) => { setPage(0); setSearch(e.target.value); }}
          />
        </div>

        {totalItems > 0 && <p className="homonym-count">{totalItems} homonyms found</p>}

        {loading ? (
          <p className="homonym-loading">Loading...</p>
        ) : items.length === 0 ? (
          <p className="homonym-empty">No homonyms found.</p>
        ) : (
          <div className="homonym-grid">
            {items.map((h) => (
              <div key={h.id} className="homonym-card" onClick={() => navigate(`/study/homonyms/${h.id}`)}>
                <h3 className="homonym-card-word">{h.word}</h3>
                {h.ipaPronunciation && <span className="homonym-card-ipa">{h.ipaPronunciation}</span>}
                {h.phoneticPronunciation && <span className="homonym-card-phonetic">{h.phoneticPronunciation}</span>}
                <span className="homonym-card-count">{h.meaningCount} meaning{h.meaningCount !== 1 ? "s" : ""}</span>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="homonym-pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>← Prev</button>
            <span>Page {page + 1} / {totalPages}</span>
            <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next →</button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default HomonymListPage;
